module.exports = __webpack_public_path__ + "static/media/LD.e0f88250.jpg";